import type { FaireProductEntity } from "../../entity_types/product";

export const p_asbwtt95gd: FaireProductEntity = {
  token: "p_asbwtt95gd",
  type: "product",
  name: "LAS Colorful Ricrac Detail Canvas Tote Bag",
  brandToken: "b_11782mgvt5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/eced6e916b0ce99fd2745d21acea2ed4a21c7bbd41ec924aa805569f5953f5a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/549b17499bef2c92eb085ead10528c221e3f774b888bbda50818b4b9782b674c.jpeg",
    "https://cdn.faire.com/fastly/ee0ee89a2af047bf195ffbe5b7775c8beb5c5415295b13dbee3ab137744d1b61.jpeg",
    "https://cdn.faire.com/fastly/3b9453c3ddd0fd0198394c194ec0e258c8b8d50562103988e7d7448e9d5e51b5.jpeg",
  ],
  priceDollars: 19.61,
  description:
    "✨Material: 100%Polyester\n✨Pattern: Colorful \n\n\n👏 Tag Customization Service: \nEach item comes with a care label that includes size information. We also offer custom brand labels and hang tags. If you need this service, feel free to reach out to us anytime! 💕",
  tags: [],
  msrpDollars: 39.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:10.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
